/**
 * Not found page.
 * @author Kacper Faber
 * @since 0.1.0
 * @constructor
 */
function NotFound() {
    return (
        <h1>
            Strona nie została odnaleziona
        </h1>
    );
}

export default NotFound;

// TODO: not-found/NotFound.tsx
//   Implement not found page.